"use client";
import Image from "next/image";
import React from "react";
import { DrupalNode } from "next-drupal";
import Link from "next/link";
import MailchimpSubscribe from "@/components/sections/MailchimpSubscribe";
import { config } from "@/lib/config";

interface LandingFooterProps {
  data: DrupalNode;
}

const Footer: React.FC<LandingFooterProps> = ({ data }) => {
  const {
    field_footer_sub_title = "",
    field_footer_menu = [],
    field_footer_social_icons = [],
  } = data;
  return (
    <footer className="relative py-[80px] bg-[#003350] betweenMobileTab:py-[60px] mobileToDesk:py-[30px]">
      <div className="absolute inset-0 z-0">
        <Image
          src="/static/images/e-logo.png"
          alt="background logo"
          fill
          priority
          className="opacity-5 mobileMax:object-cover"
        />
      </div>
      <div className="mini-container relative">
        <Image
          src="/static/images/footer-logo-1.svg"
          alt="logo"
          width={60}
          height={60}
          className="mx-auto block mb-2 mobileMax:w-[50px]"
        />
        <h2 className="text-[#48DBB2] text-[24px] text-center mb-[30px] font-poppins font-[400] mobileMax:text-xmedium">
          {field_footer_sub_title}
        </h2>
        <p className="text-center text-[14px] mobileMax:text-xsmall font-[300] text-white leading-normal uppercase tracking-[2px]">
          Follow Us
        </p>
        <nav
          aria-label="Social Media Links"
          className="flex items-center justify-center mt-[12px] mb-[75px] gap-5 betweenMobileTab:mb-[60px] mobileToDesk:mb-[40px]"
        >
          {field_footer_social_icons?.map(
            (socialIcon: DrupalNode, index: number) => {
              return (
                <Link
                  className="landing-footer-links"
                  key={index}
                  href={socialIcon?.field_social_media_link || "#"}
                  target="_blank"
                >
                  <Image
                    src={`${config.apiBase}${
                      socialIcon?.field_social_media_logo?.uri?.url || ""
                    }`}
                    alt="img"
                    width={40}
                    height={40}
                    className="mobileMax:w-[30px]"
                  />
                </Link>
              );
            },
          )}
        </nav>
        <div className="pb-[60px] mobileMax:py-8 ">
          <MailchimpSubscribe />
        </div>
        <ul className="flex items-center justify-center mobileMax:flex-wrap gap-[50px] mobileMax:mt-[30px] mobileMax:gap-[12px]">
          {field_footer_menu?.map((menuItem: DrupalNode, index: number) => {
            const isContact = menuItem?.title
              ?.toLowerCase()
              .includes("contact");

            const href = isContact
              ? `mailto:${menuItem?.field_menu_link}`
              : menuItem?.field_menu_link || "#";

            return (
              <li key={index}>
                <Link
                  href={href}
                  target={isContact ? "_self" : "_blank"}
                  rel={isContact ? undefined : "noopener noreferrer"}
                  className="text-center leading-[25px] text-[14px] mobileMax:text-xsmall hover:text-[#48DBB2] font-poppins cursor-pointer text-white"
                >
                  {menuItem?.title || ""}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
